import { PostAPI } from 'Components/Helper/Helpers';

export const MerchantOnboarding = async (request) => {
    return PostAPI(request, 'OnlyApiOnbaording/MerchantOnboarding');
};

export const CheckOnboardingStatus = async (request) => {
    return PostAPI(request, 'OnlyApiOnbaording/CheckOnboardingStatus');
};

export const BulkOnboarding = async (request) => {
    return PostAPI(request, 'OnlyApiOnbaording/BulkOnboarding');
};